





















import Vue from 'vue'
import ContestItem from '@/components/contest/ContestItem.vue'
import ServerPaginationList from '@/components/ServerPaginationList.vue'

export default Vue.extend({
  name: 'ContestList',

  components: {
    ContestItem,
    ServerPaginationList,
  },

  props: {
    filter: {
      type: String,
    },

    projectId: {
      type: String,
    },
  },

  computed: {
    actionUrl: function (): string {
      const actions: {[key: string]: string} = {
        "finished": "/contests/close?order[endAt]=desc",
        "readyForUserApplication": "/contests/readyForUserApplication",
        "coming-soon": "/contests/comingSoon?order[publicAt]=asc"
      }

      return actions[this.filter] ?? "/contests/open.jsonld?order[endAt]=asc"
    },

    isActiveApplyContest: function (): boolean {
      return this.filter === "readyForUserApplication";
    },
  },

  data: () => ({}),
})
